<button mat-button (click)="prevPage()"> <</button>
Strona : {{actualPage + 1}}/{{getLastPageNum() + 1}}
<button mat-button (click)="nextPage()"> ></button>
<button mat-button (click)="clearHistory()">usuń historię</button>
<hr>
  <app-history-item *ngFor="let weather of getPagList()" [historyItem]="weather"></app-history-item>
